import React from 'react'
import ReactDOM from 'react-dom/client'
import reportWebVitals from './reportWebVitals'
import { RouterProvider } from 'react-router-dom'
import { router } from './routes'
import { Global, ThemeProvider } from '@emotion/react'
import { theme } from '@yuno/sdk-web-core/dist/theme'
import { ReactQueryDevtools } from '@tanstack/react-query-devtools'
import { resetCss } from './styles'
import { QueryProvider } from './state'
import './i18n'
import { loadScript } from '@yuno-payments/sdk-web'
import { requestLocationPermission } from './utils/geolocation'
loadScript({
  env: process.env.REACT_APP_SDK_WEB_ENV as any || 'prod',
  version: process.env.REACT_APP_SDK_WEB_VERSION as any || 'v1.3'
})

console.log('checkout-version: ', process.env.REACT_APP_VERSION)

const App = () => {
  return (
    <React.StrictMode>
      <ThemeProvider theme={theme}>
        <Global styles={[resetCss]} />
        <QueryProvider>
          <RouterProvider router={router} />
          <ReactQueryDevtools initialIsOpen={false} />
        </QueryProvider>
      </ThemeProvider>
    </React.StrictMode>
  ) 
}

requestLocationPermission().then((position) => {
  console.log('position', position)
}).catch((error) => {
  console.log('error', error)
})

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement)
root.render(<App />)

reportWebVitals()
